import axios from "axios";

const baseUrl = process.env.REACT_APP_API_URL;

/**
 * Realiza el registro de un cliente por medio del an8
 * @param {String} username - an8 del cliente
 * @returns Respuesta de la solicitud
 * @author alSanchez - ETE
 * @version 1.0.0 - Septiembre 2021
 */ 
const registerClient = (username) => {

  //  const token = localStorage.getItem('initToken');

  return axios.post(baseUrl + "/user", {
    noCustomer: username
  },
  // {
  //   headers: {
  //     Authorization: 'Bearer ' + token
  //   }
  // }
);
};

/**
 * Realiza el registro de un empleado por medio del an8
 * @param {String} username - an8 del empleado
 * @returns Respuesta de la solicitud
 * @author alSanchez - ETE
 * @version 1.0.0 - Febrero 2023
 */ 
const registerEmployee = (an8) => {

  // const token = localStorage.getItem('initToken');

  return axios.post(baseUrl + "/zone-administrator/save", {
    noCustomer: an8
  },
  // {
  //   headers: {
  //     Authorization: 'Bearer ' + token
  //   }
  // }
  ).then(response => {
    return response.data;
   }
   );
};

/**
 * Realiza la confirmación del registro de un cliente por medio del an8
 * @param {String} username - an8 del cliente
 * @returns {any} recupera la respuesta de la solicitud
 * @author alSanchez - ETE
 * @version 1.0.0 - Septiembre 2021
 */ 
const confirmRegister = (username) => {
  // const token = localStorage.getItem('initToken');

  const url = `${baseUrl}/user/confirmation/${username}`

  return axios.put(url,username,
  // {
  //   headers: {
  //     Authorization: 'Bearer ' + token
  //   }
  // }
  ).then(response => {
    console.log(response)
    return response.data;
   }
   );

}

/**
 * Realiza el inicio de sesión del cliente por medio de credenciales
 * @param { String } username - an8 del cliente
 * @param { String } password - Clave del cliente
 * @param { String } rol  - rol asociado al an8
 * @returns { Array } devuelve el arreglo con los datos del cliente autenticado
 * @author alSanchez - ETE
 * @version 1.0.0 - Septiembre 2021
 */
const login = (noCustomer, password) => {
  const url = `${ baseUrl }/auth/login`;
  return axios
    .post(url, {
      noCustomer,
      password
    })
    .then(response => {
      if (response.data.token) {
        localStorage.setItem("client", JSON.stringify(response.data));
        localStorage.setItem("timeSesion", new Date());
      }
      return response.data;
     }
     )
};

/**
 * Realiza el cierre de sesión eliminado la información del cliente autenticado
 * @author alSanchez - ETE
 * @version 1.0.0 - Septiembre 2021
 */ 
const logout = () => {
  localStorage.removeItem("client");
  localStorage.removeItem('timeSesion');
};

/**
 * Realiza la recuperación de contraseña por medio del an8
 * @param {String} username - an8 del cliente
 * @returns {any} recupera la respuesta de la solicitud
 * @author alSanchez - ETE
 * @version 1.0.0 - Enero 2024
 */ 
const recoverPassword = (username) => {
  // const token = localStorage.getItem('initToken');

  const url = `${baseUrl}/user/recover-password/${username}`

  return axios.put(url,username,
  // {
  //   headers: {
  //     Authorization: 'Bearer ' + token
  //   }
  // }
).then(response => {
    console.log(response)
    return response.data;
   }
   );

}

export default {
  registerClient,
  registerEmployee,
  confirmRegister,
  login,
  logout,
  recoverPassword
};